module.exports = __webpack_public_path__ + "img/youtube.2f90a4ae.svg";